/* eslint-disable */

/**
 * Determine rem based on the pixel sized provided by our design system.
 * @param {number} fontSizePx
 */
export const pixelToRem = fontSizePx => {
  const defaultSize = 16;
  const remSize = fontSizePx / defaultSize;
  return `${remSize}rem`;
};